import { AnimatedOutlet } from '$components'
import { PageLayout } from '$layouts/page'
import { LinkButton, Tabs, Text, Tooltip } from '$components'
import { SendIcon } from '$components'
import { TeamRoutePath } from '../routes/protected'
import { useLocation } from 'react-router-dom'
import { Router } from '$utils/router'
import { useAuth } from '$features/auth/hooks/use-auth'
import { PermissionsHelper } from '$utils/permissions'
import { Role } from '$api-client/types.gen'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'
import { usePageTitle } from '$components'

export function TeamPage() {
  usePageTitle('Team')

  const location = useLocation()
  const { user } = useAuth()
  const { hasSubscriptionExpired } = useTenant()

  const activeTab = location.pathname.split('/').pop()

  return (
    <PageLayout>
      <div className="flex flex-col gap-stack-section pb-stack-roomy">
        <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto] md:grid-cols-[1fr_auto_auto] gap-stack-roomy">
          <div className="space-y-stack-dense">
            <Text
              type="h1"
              weight="medium"
            >
              Team Members
            </Text>
            <Text type="s">
              Manage your organization&apos;s team members and invitations
            </Text>
          </div>

          <div className="flex items-center gap-stack-roomy col-start-1 row-start-2 md:col-start-2 md:row-start-1">
            <Tabs>
              <Tabs.Tab to={TeamRoutePath.TeamMembers}>
                Team Members
              </Tabs.Tab>

              <Tabs.Tab
                to={TeamRoutePath.TeamInvitations}
                disabled={PermissionsHelper.doesntHaveRole(user.role, [Role.SUPER_ADMIN, Role.ADMIN])}
              >
                Pending Invitations
              </Tabs.Tab>
            </Tabs>
          </div>

          <div className="justify-self-end self-center w-full">
            <Tooltip
              content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : PermissionsHelper.doesntHaveRole(user.role, [Role.SUPER_ADMIN, Role.ADMIN]) ? 'Only administrators can invite members.' : undefined}
              disabled={!hasSubscriptionExpired && PermissionsHelper.hasRole(user.role, [Role.SUPER_ADMIN, Role.ADMIN])}
            >
              <LinkButton
                size="md"
                variant="primary"
                icon={SendIcon}
                to={Router.buildRoute(TeamRoutePath.Team, activeTab!, TeamRoutePath.TeamInviteMember)}
                disabled={hasSubscriptionExpired || PermissionsHelper.doesntHaveRole(user.role, [Role.SUPER_ADMIN, Role.ADMIN])}
                className="w-full sm:w-auto"
              >
                Invite Member
              </LinkButton>
            </Tooltip>
          </div>
        </div>

        <AnimatedOutlet />
      </div>
    </PageLayout>
  )
}
